import { IPintagBoxStatus } from "../typings/interfaces/pos/pintag";

const DAYS = ["SUNDAY", "MONDAY", "TUESDAY", "WEDNESDAY", "THURSDAY", "FRIDAY", "SATURDAY"];

/** "000–049" */
export const bookLabel = (start: number, end: number) =>
  `${String(start).padStart(3, "0")}–${String(end).padStart(3, "0")}`;

/** The pin tag colour for a day (the store's today by default), else the first colour. */
export const colourForDay = (colours: IPintagBoxStatus[], date: Date) =>
  colours.find((c) => c.day === DAYS[date.getDay()]) ?? colours[0];
